/**
 * Global emitter
 */
import {globalEvent as emitter} from '@billjs/event-emitter';
export default emitter;